// The default document title, used by every page that isn't a restaurant or
// recommender detail page (those set their own, and api/page.js overrides them
// server-side for crawlers).
//
// This was inlined in three separate components, which is how a copy pass
// nearly missed some of them. One constant now, so the next rewording is a
// single edit.
//
// ⚠️ `public/index.html` carries the same string in its <title>, `og:title`,
// and `twitter:title`. It's static HTML and can't import this, so those four
// must be changed together. (Same tradeoff as FULL_LIST_SIZE in fullList.ts.)
export const DEFAULT_PAGE_TITLE =
  'Best St. Louis Restaurants, Ranked by Real People | Rankum';
